import IndexPage from "./IndexPage"
import TalkAndTranslatePage from "./TalkAndTranslatePage"
import HCHome from "../Help-Center/HCHome"
import MoreDictionariesPage from "./MoreDictionariesPage"
import BlogHome from "../Blog/home"
import BlogPostPage from "./BlogPostPage"
import AccountPage from "./AccountPage/AccountPage"
import PartnerWithUsPage from "./PartnerWithUsPage"
import PricingPage from "./PricingPage"
import NotFoundPage from "./NotFoundPage"
import Faq from "./Faq"
import Features from "./Features"
import PP from "../PrivacyPolicy-TOS/pp"
import TOS from "../PrivacyPolicy-TOS/tos"

// Register all site page routes at once using an object
export default {
  "/": IndexPage,
  "/terms-of-use": TOS,
  "/talk-and-translate": TalkAndTranslatePage,
  "/help-center": HCHome,
  "/help-center/*": HCHome,
  "/more-dictionaries": MoreDictionariesPage,
  "/privacy-policy": PP,
  "/privacy-policy/terms-of-use": TOS,
  "/faq": Faq,
  "/features": Features,
  "/blog": BlogHome,
  "/blog/*": BlogPostPage,
  "/account": AccountPage,
  "/partner-with-us": PartnerWithUsPage,
  "/pricing": PricingPage,
  "/404": NotFoundPage,
}